import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

const XCircle = () => (
  <div className="relative w-[120px] h-[120px] rounded-full bg-[#fde0e5] flex items-center justify-center">
    <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="10" stroke="#e14b6b" strokeWidth="2" />
      <path d="M8.5 8.5l7 7M15.5 8.5l-7 7" stroke="#e14b6b" strokeWidth="2" strokeLinecap="round" />
    </svg>
  </div>
)

const ExpiredModal = () => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const [state, setState] = useState(null)

  useEffect(() => {
    const handler = (e) => setState(e.detail)
    window.addEventListener('reilm:subscription-expired', handler)
    return () => window.removeEventListener('reilm:subscription-expired', handler)
  }, [])

  // The modal belongs to the page that triggered it — leaving that page dismisses it.
  useEffect(() => { setState(null) }, [pathname])

  if (!state) return null

  const isTrial = state === 'trial'

  const close = () => setState(null)
  const goPlans = () => {
    close()
    navigate('/pricing')
  }
  const reactivate = () => {
    close()
    navigate('/payment?plan=pro&billing=monthly')
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30" role="dialog" aria-modal="true">
      <div className="relative w-[560px] max-w-[calc(100vw-32px)] bg-brand-greenSec rounded-[24px] px-6 md:px-10 py-10 md:py-12 flex flex-col items-center gap-8 shadow-[0_20px_60px_rgba(0,0,0,0.25)]">
        <button
          type="button"
          onClick={close}
          aria-label="Close"
          className="absolute top-5 right-5 text-brand-dark"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </button>

        <XCircle />

        <div className="flex flex-col items-center gap-3 text-center">
          <h2 className="text-[24px] font-extrabold text-brand-dark">
            {isTrial ? 'Your free trial has expired.' : 'Your subscription has expired.'}
          </h2>
          <p className="text-[16px] text-brand-dark">
            {isTrial ? 'Select a plan to continue using Arvance.' : 'Reactivate to continue using Arvance.'}
          </p>
        </div>

        {isTrial ? (
          <button
            type="button"
            onClick={goPlans}
            className="w-full max-w-[264px] h-[56px] rounded-full bg-[#e14b6b] text-white text-[16px] font-semibold"
          >
            View Plans
          </button>
        ) : (
          <div className="w-full flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              type="button"
              onClick={goPlans}
              className="w-full sm:w-auto h-[56px] px-8 rounded-full bg-white border border-[#cbdcc3] text-brand-dark text-[16px] font-semibold"
            >
              View Plans
            </button>
            <button
              type="button"
              onClick={reactivate}
              className="w-full sm:w-auto h-[56px] px-8 rounded-full bg-[#e14b6b] text-white text-[16px] font-semibold"
            >
              Reactivate Subscription
            </button>
          </div>
        )}

        <a
          href="mailto:support@reilm.io"
          className="text-[14px] text-brand-dark"
        >
          Need help? <span className="font-semibold">Contact Support</span>
        </a>
      </div>
    </div>
  )
}

export default ExpiredModal
